<template>
  <div
    v-if="section === currentSection"
    :class="sectionClass"
    :ref="section.name || section"
    :key="section.name"
    :id="'Section_'+section.name"
  >
    <div class="tabdisableoverlay" v-if="section.tabDisabled">
      <h1 class="text-danger font-400">
        <i class="fa fa-ban fa-fw"></i>Zakładka jest wyłączona z edycji
      </h1>
    </div>
    <div v-else-if="section.unlockInfo && section.unlockInfo.length && section.tabEnabled">
      <h4 class="no-padding margin-bottom-5 text-warning">
        <i class="fa fa-warning fa-fw"></i>Opis wymaganych zmian
      </h4>
      <div class="alert alert-warning" style="white-space: pre-wrap;">{{section.unlockInfo}}</div>
    </div>

    <h1 v-if="section.description">{{section.description}}</h1>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'w-section',
  props: {
    section: Object,
    currentSection: Object,
    sectionClass: {
      type: String,
      default: 'smart-form well'
    }
  }
};
</script>


<style scoped>
.tabdisableoverlay {
  left: 0px;
  top: 0px;
  text-align: center;
  right: 0px;
  bottom: 0px;
  padding-top: 10px;
  font-weight: bold;
  position: absolute;
  z-index: 1000;
  opacity: 0.7;
  background-color: white;
}
</style>
